import { ValidationRule } from '../validation.rule';
import { ValidationTypes } from '../validationtypes';

export class RequiredTrueValidationRule extends ValidationRule {
  constructor() {
    super(ValidationTypes.requiredTrue);
  }

  isValid(value: any): boolean {
    return value !== null && value === true;
  }
}
